

export default {
  locale: 'hr',
  Pagination: {
    items_per_page: '/ str',
    jump_to: 'Idi na',
    jump_to_confirm: 'potvrdi',
    page: '',
    prev_page: 'Prijašnja stranica',
    next_page: 'Sljedeća stranica',
    prev_5: 'Prijašnjih 5 stranica',
    next_5: 'Sljedećih 5 stranica',
    prev_3: 'Prijašnje 3 stranice',
    next_3: 'Sljedeće 3 stranice',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'Odaberite datum',
      rangePlaceholder: ['Početni datum', 'Završni datum'],
      locale: 'hr_HR',
      today: 'Danas',
      now: 'Sad',
      backToToday: 'Natrag na danas',
      ok: 'Ok',
      clear: 'Očisti',
      month: 'Mjesec',
      year: 'Godina',
      timeSelect: 'odaberite vrijeme',
      dateSelect: 'odaberite datum',
      weekSelect: 'Odaberite tjedan',
      monthSelect: 'Odaberite mjesec',
      yearSelect: 'Odaberite godinu',
      decadeSelect: 'Odaberite desetljeće',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prošli mjesec (PageUp)',
      nextMonth: 'Sljedeći mjesec (PageDown)',
      previousYear: 'Prošla godina (Control + left)',
      nextYear: 'Sljedeća godina (Control + right)',
      previousDecade: 'Prošlo desetljeće',
      nextDecade: 'Sljedeće desetljeće',
      previousCentury: 'Prošlo stoljeće',
      nextCentury: 'Sljedeće stoljeće',
      yearPlaceholder: 'Odaberite godinu',
      quarterPlaceholder: 'Odaberite četvrtinu',
      monthPlaceholder: 'Odaberite mjesec',
      weekPlaceholder: 'Odaberite tjedan',
      rangeYearPlaceholder: ['Početna godina', 'Završna godina'],
      rangeMonthPlaceholder: ['Početni mjesec', 'Završni mjesec'],
      rangeWeekPlaceholder: ['Početni tjedan', 'Završni tjedan']
    },
    timePickerLocale: {
      placeholder: 'Odaberite vrijeme',
      rangePlaceholder: ['Vrijeme početka', 'Vrijeme završetka']
    }
  },
  TimePicker: {
    placeholder: 'Odaberite vrijeme',
    rangePlaceholder: ['Vrijeme početka', 'Vrijeme završetka']
  },
  Calendar: {
    lang: {
      placeholder: 'Odaberite datum',
      rangePlaceholder: ['Početni datum', 'Završni datum'],
      locale: 'hr_HR',
      today: 'Danas',
      now: 'Sad',
      backToToday: 'Natrag na danas',
      ok: 'Ok',
      clear: 'Očisti',
      month: 'Mjesec',
      year: 'Godina',
      timeSelect: 'odaberite vrijeme',
      dateSelect: 'odaberite datum',
      weekSelect: 'Odaberite tjedan',
      monthSelect: 'Odaberite mjesec',
      yearSelect: 'Odaberite godinu',
      decadeSelect: 'Odaberite desetljeće',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prošli mjesec (PageUp)',
      nextMonth: 'Sljedeći mjesec (PageDown)',
      previousYear: 'Prošla godina (Control + left)',
      nextYear: 'Sljedeća godina (Control + right)',
      previousDecade: 'Prošlo desetljeće',
      nextDecade: 'Sljedeće desetljeće',
      previousCentury: 'Prošlo stoljeće',
      nextCentury: 'Sljedeće stoljeće',
      yearPlaceholder: 'Odaberite godinu',
      quarterPlaceholder: 'Odaberite četvrtinu',
      monthPlaceholder: 'Odaberite mjesec',
      weekPlaceholder: 'Odaberite tjedan',
      rangeYearPlaceholder: ['Početna godina', 'Završna godina'],
      rangeMonthPlaceholder: ['Početni mjesec', 'Završni mjesec'],
      rangeWeekPlaceholder: ['Početni tjedan', 'Završni tjedan']
    },
    timePickerLocale: {
      placeholder: 'Odaberite vrijeme',
      rangePlaceholder: ['Vrijeme početka', 'Vrijeme završetka']
    }
  },
  global: {
    placeholder: 'Molimo označite'
  },
  Table: {
    filterTitle: 'Filter meni',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Označi trenutnu stranicu',
    selectInvert: 'Invertiraj trenutnu stranicu',
    sortTitle: 'Sortiraj',
    filterEmptyText: 'Nema filtera',
    emptyText: 'Nema podataka',
    selectionAll: 'Odaberite sve podatke',
    expand: 'Proširi redak',
    collapse: 'Sažmi redak',
    triggerDesc: 'Kliknite za sortiranje silazno',
    triggerAsc: 'Kliknite za sortiranje uzlazno',
    cancelSort: 'Kliknite da biste otkazali sortiranje'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Odustani',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Odustani'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Pretraži ovdje',
    itemUnit: 'stavka',
    itemsUnit: 'stavke',
    remove: 'Ukloniti',
    selectCurrent: 'Odaberite trenutnu stranicu',
    removeCurrent: 'Ukloni trenutnu stranicu',
    selectAll: 'Odaberite sve podatke',
    removeAll: 'Uklonite sve podatke',
    selectInvert: 'Obrni trenutnu stranicu'
  },
  Upload: {
    uploading: 'Upload u tijeku...',
    removeFile: 'Makni datoteku',
    uploadError: 'Greška kod uploada',
    previewFile: 'Pogledaj datoteku',
    downloadFile: 'Preuzmi datoteku'
  },
  Empty: {
    description: 'Nema podataka'
  },
  Icon: {
    icon: 'ikona'
  },
  Text: {
    edit: 'Uredi',
    copy: 'Kopiraj',
    copied: 'Kopiranje uspješno',
    expand: 'Proširi'
  },
  PageHeader: {
    back: 'Natrag'
  },
  Image: {
    preview: 'Pregled'
  }
};
